type Perimeter = string
type Cost = string

export type PerimetersAndCosts = { [perimeter in Perimeter]: Cost }

/**
 * Элемент массива - это кол-во этикеток на штампе
 */
export const stampCosts: PerimetersAndCosts[] = [
    {
        '25': '4331',
        '50': '4331',
        '100': '4331',
        '150': '4331',
        '200': '4331',
        '250': '4331',
        '300': '4331',
        '350': '4331',
        '400': '4331',
        '450': '4331',
        '500': '4331',
        '600': '4331',
        '700': '4331',
        '800': '4331',
        '900': '4331',
        '1000': '4331',
        '1200': '4331',
        '1400': '4331',
        '1600': '4331',
        '1800': '4331',
        '2000': '6892',
    },
    {
        '25': '4331',
        '50': '4331',
        '100': '4331',
        '150': '4331',
        '200': '4331',
        '250': '4331',
        '300': '4331',
        '350': '4331',
        '400': '4331',
        '450': '4331',
        '500': '4331',
        '600': '4331',
        '700': '4331',
        '800': '4331',
        '900': '4331',
        '1000': '4331',
        '1200': '7642',
        '1400': '8536',
        '1600': '9433',
        '1800': '10370',
        '2000': '11290',
    },
    {
        '25': '4331',
        '50': '4331',
        '100': '4331',
        '150': '4331',
        '200': '4331',
        '250': '4331',
        '300': '4331',
        '350': '4331',
        '400': '4331',
        '450': '4331',
        '500': '6658',
        '600': '7190',
        '700': '7491',
        '800': '7788',
        '900': '8387',
        '1000': '8785',
        '1200': '10035',
        '1400': '11418',
        '1600': '12710',
        '1800': '14026',
        '2000': '15121',
    },
    {
        '25': '4331',
        '50': '4331',
        '100': '4331',
        '150': '4331',
        '200': '4331',
        '250': '4331',
        '300': '7113',
        '350': '7190',
        '400': '7788',
        '450': '8240',
        '500': '8536',
        '600': '8686',
        '700': '8835',
        '800': '8984',
        '900': '9135',
        '1000': '9322',
        '1200': '11716',
        '1400': '13135',
        '1600': '15154',
        '1800': '17065',
        '2000': '18860',
    },
    {
        '25': '4331',
        '50': '4331',
        '100': '4331',
        '150': '4331',
        '200': '7037',
        '250': '7376',
        '300': '7863',
        '350': '7974',
        '400': '8575',
        '450': '9022',
        '500': '9433',
        '600': '9807',
        '700': '10184',
        '800': '10554',
        '900': '10929',
        '1000': '11341',
        '1200': '13212',
        '1400': '14856',
        '1600': '16989',
        '1800': '18748',
        '2000': '20609',
    },
    {
        '25': '4331',
        '50': '4331',
        '100': '7227',
        '150': '7340',
        '200': '7713',
        '250': '8087',
        '300': '8611',
        '350': '8759',
        '400': '9360',
        '450': '9807',
        '500': '10333',
        '600': '10707',
        '700': '11079',
        '800': '11455',
        '900': '11827',
        '1000': '12200',
        '1200': '14709',
        '1400': '16579',
        '1600': '19232',
        '1800': '20431',
        '2000': '22601',
    },
    {
        '25': '4331',
        '50': '6741',
        '100': '7863',
        '150': '8013',
        '200': '8387',
        '250': '8798',
        '300': '9360',
        '350': '9547',
        '400': '10146',
        '450': '10595',
        '500': '11229',
        '600': '11604',
        '700': '12275',
        '800': '12948',
        '900': '13623',
        '1000': '14372',
        '1200': '16204',
        '1400': '18299',
        '1600': '21375',
        '1800': '22794',
        '2000': '25212',
    },
    {
        '25': '4331',
        '50': '7190',
        '100': '8496',
        '150': '8686',
        '200': '9059',
        '250': '9510',
        '300': '10110',
        '350': '10333',
        '400': '10929',
        '450': '11378',
        '500': '12127',
        '600': '12504',
        '700': '13398',
        '800': '14298',
        '900': '15195',
        '1000': '16166',
        '1200': '17701',
        '1400': '20021',
        '1600': '23514',
        '1800': '24884',
        '2000': '27196',
    },
    {
        '25': '4331',
        '50': '7642',
        '100': '9135',
        '150': '9360',
        '200': '9732',
        '250': '10218',
        '300': '10857',
        '350': '11120',
        '400': '11716',
        '450': '12167',
        '500': '13024',
        '600': '13514',
        '700': '14519',
        '800': '15645',
        '900': '16651',
        '1000': '17997',
        '1200': '19200',
        '1400': '21743',
        '1600': '25654',
        '1800': '26972',
        '2000': '29304',
    },
    {
        '25': '4331',
        '50': '8087',
        '100': '9770',
        '150': '10035',
        '200': '10406',
        '250': '10929',
        '300': '11604',
        '350': '11904',
        '400': '12504',
        '450': '12948',
        '500': '13811',
        '600': '14146',
        '700': '15645',
        '800': '16989',
        '900': '18113',
        '1000': '19382',
        '1200': '20693',
        '1400': '23462',
        '1600': '27797',
        '1800': '29066',
        '2000': '30571',
    },
    {
        '25': '4331',
        '50': '8536',
        '100': '10406',
        '150': '10707',
        '200': '11079',
        '250': '11640',
        '300': '12352',
        '350': '12688',
        '400': '13287',
        '450': '13735',
        '500': '14596',
        '600': '14933',
        '700': '16651',
        '800': '17997',
        '900': '19120',
        '1000': '20393',
        '1200': '21778',
        '1400': '24546',
        '1600': '28623',
        '1800': '30194',
        '2000': '31831',
    },
    {
        '25': '6966',
        '50': '8984',
        '100': '11043',
        '150': '11378',
        '200': '11754',
        '250': '12352',
        '300': '13097',
        '350': '13473',
        '400': '14074',
        '450': '14560',
        '500': '15383',
        '600': '15719',
        '700': '17663',
        '800': '19010',
        '900': '20130',
        '1000': '21405',
        '1200': '22864',
        '1400': '25632',
        '1600': '29451',
        '1800': '31324',
        '2000': '33097',
    },
    {
        '25': '7190',
        '50': '9433',
        '100': '11678',
        '150': '12053',
        '200': '12425',
        '250': '13062',
        '300': '13846',
        '350': '14260',
        '400': '14856',
        '450': '15383',
        '500': '16166',
        '600': '16504',
        '700': '18671',
        '800': '20021',
        '900': '21143',
        '1000': '22415',
        '1200': '23948',
        '1400': '26717',
        '1600': '30282',
        '1800': '32457',
        '2000': '34363',
    },
    {
        '25': '7413',
        '50': '9807',
        '100': '12313',
        '150': '12726',
        '200': '13097',
        '250': '13773',
        '300': '14596',
        '350': '15045',
        '400': '15645',
        '450': '16204',
        '500': '16953',
        '600': '17291',
        '700': '19684',
        '800': '21029',
        '900': '22153',
        '1000': '23424',
        '1200': '25031',
        '1400': '27800',
        '1600': '31109',
        '1800': '33583',
        '2000': '35625',
    },
    {
        '25': '7642',
        '50': '10184',
        '100': '12948',
        '150': '13398',
        '200': '13773',
        '250': '14486',
        '300': '15344',
        '350': '15831',
        '400': '16429',
        '450': '17029',
        '500': '17736',
        '600': '18073',
        '700': '20693',
        '800': '22040',
        '900': '23161',
        '1000': '24433',
        '1200': '26119',
        '1400': '28883',
        '1600': '31936',
        '1800': '34714',
        '2000': '36890',
    },
    {
        '25': '7863',
        '50': '10554',
        '100': '13587',
        '150': '14074',
        '200': '14447',
        '250': '15195',
        '300': '16091',
        '350': '16617',
        '400': '17216',
        '450': '17850',
        '500': '18526',
        '600': '18860',
        '700': '21704',
        '800': '23050',
        '900': '24173',
        '1000': '25445',
        '1200': '27202',
        '1400': '29971',
        '1600': '32765',
        '1800': '35847',
        '2000': '37601',
    },
    {
        '25': '8087',
        '50': '10929',
        '100': '14223',
        '150': '14749',
        '200': '15121',
        '250': '15905',
        '300': '16842',
        '350': '17401',
        '400': '17997',
        '450': '18671',
        '500': '19308',
        '600': '19645',
        '700': '22713',
        '800': '24057',
        '900': '25179',
        '1000': '26452',
        '1200': '28286',
        '1400': '31057',
        '1600': '33594',
        '1800': '36973',
        '2000': '39416',
    },
    {
        '25': '8314',
        '50': '11303',
        '100': '14856',
        '150': '15417',
        '200': '15793',
        '250': '16617',
        '300': '17588',
        '350': '18187',
        '400': '18784',
        '450': '19495',
        '500': '20095',
        '600': '20431',
        '700': '23725',
        '800': '25069',
        '900': '26193',
        '1000': '27465',
        '1200': '29371',
        '1400': '32137',
        '1600': '34422',
        '1800': '38105',
        '2000': '40683',
    },
    {
        '25': '8536',
        '50': '11678',
        '100': '15493',
        '150': '16091',
        '200': '16466',
        '250': '17325',
        '300': '18336',
        '350': '18972',
        '400': '19572',
        '450': '20320',
        '500': '20879',
        '600': '21216',
        '700': '24732',
        '800': '26081',
        '900': '27202',
        '1000': '28475',
        '1200': '30456',
        '1400': '33225',
        '1600': '35251',
        '1800': '39235',
        '2000': '41342',
    },
    {
        '25': '8759',
        '50': '12053',
        '100': '16130',
        '150': '16766',
        '200': '17139',
        '250': '18037',
        '300': '19086',
        '350': '19758',
        '400': '20358',
        '450': '20879',
        '500': '21669',
        '600': '22005',
        '700': '25742',
        '800': '26865',
        '900': '28210',
        '1000': '29485',
        '1200': '31539',
        '1400': '34308',
        '1600': '36080',
        '1800': '40364',
        '2000': '43209',
    },
    {
        '25': '8984',
        '50': '12352',
        '100': '16504',
        '150': '17178',
        '200': '17550',
        '250': '18450',
        '300': '19495',
        '350': '20244',
        '400': '20918',
        '450': '21441',
        '500': '22189',
        '600': '22601',
        '700': '26490',
        '800': '27651',
        '900': '28921',
        '1000': '30117',
        '1200': '32327',
        '1400': '35206',
        '1600': '37153',
        '1800': '41415',
        '2000': '44371',
    },
    {
        '25': '9211',
        '50': '12652',
        '100': '16880',
        '150': '17588',
        '200': '17963',
        '250': '18860',
        '300': '19911',
        '350': '20730',
        '400': '21481',
        '450': '22005',
        '500': '22713',
        '600': '23199',
        '700': '27237',
        '800': '28434',
        '900': '29631',
        '1000': '30828',
        '1200': '33114',
        '1400': '36103',
        '1600': '38223',
        '1800': '42465',
        '2000': '45534',
    },
    {
        '25': '9433',
        '50': '12948',
        '100': '17252',
        '150': '17997',
        '200': '18373',
        '250': '19276',
        '300': '20320',
        '350': '21216',
        '400': '22040',
        '450': '22564',
        '500': '23236',
        '600': '23799',
        '700': '27987',
        '800': '29222',
        '900': '30343',
        '1000': '31539',
        '1200': '33898',
        '1400': '37000',
        '1600': '39297',
        '1800': '43520',
        '2000': '46691',
    },
    {
        '25': '9660',
        '50': '13251',
        '100': '17627',
        '150': '18413',
        '200': '18784',
        '250': '19684',
        '300': '20730',
        '350': '21704',
        '400': '22601',
        '450': '23124',
        '500': '23758',
        '600': '24392',
        '700': '28736',
        '800': '30007',
        '900': '31057',
        '1000': '32251',
        '1200': '34682',
        '1400': '37901',
        '1600': '40369',
        '1800': '44569',
        '2000': '47853',
    },
    {
        '25': '9880',
        '50': '13548',
        '100': '17997',
        '150': '18823',
        '200': '19200',
        '250': '20095',
        '300': '21143',
        '350': '22189',
        '400': '23161',
        '450': '23686',
        '500': '24285',
        '600': '24997',
        '700': '29485',
        '800': '30792',
        '900': '31765',
        '1000': '32958',
        '1200': '35468',
        '1400': '38798',
        '1600': '41441',
        '1800': '45622',
        '2000': '48820',
    },
    {
        '25': '10110',
        '50': '13846',
        '100': '18373',
        '150': '19237',
        '200': '19611',
        '250': '20507',
        '300': '21554',
        '350': '22675',
        '400': '23725',
        '450': '24247',
        '500': '24807',
        '600': '25595',
        '700': '30234',
        '800': '31578',
        '900': '32476',
        '1000': '33672',
        '1200': '36255',
        '1400': '39696',
        '1600': '42513',
        '1800': '46671',
        '2000': '50177',
    },
    {
        '25': '10333',
        '50': '14146',
        '100': '18748',
        '150': '19645',
        '200': '20021',
        '250': '20918',
        '300': '21964',
        '350': '23161',
        '400': '24285',
        '450': '24807',
        '500': '25332',
        '600': '26193',
        '700': '30981',
        '800': '32365',
        '900': '33187',
        '1000': '34384',
        '1200': '37039',
        '1400': '40593',
        '1600': '43586',
        '1800': '47723',
        '2000': '51337',
    },
    {
        '25': '10554',
        '50': '14447',
        '100': '19120',
        '150': '20057',
        '200': '20431',
        '250': '21332',
        '300': '22378',
        '350': '23647',
        '400': '24847',
        '450': '25369',
        '500': '25855',
        '600': '26790',
        '700': '31727',
        '800': '33148',
        '900': '33898',
        '1000': '35096',
        '1200': '37824',
        '1400': '41492',
        '1600': '44656',
        '1800': '48774',
        '2000': '52497',
    },
    {
        '25': '10783',
        '50': '14749',
        '100': '19495',
        '150': '20470',
        '200': '20843',
        '250': '21743',
        '300': '22787',
        '350': '24138',
        '400': '25406',
        '450': '25932',
        '500': '26377',
        '600': '27390',
        '700': '32476',
        '800': '33935',
        '900': '34605',
        '1000': '35807',
        '1200': '38611',
        '1400': '42386',
        '1600': '45730',
        '1800': '49823',
        '2000': '53660',
    },
    {
        '25': '11003',
        '50': '15045',
        '100': '19867',
        '150': '20879',
        '200': '21251',
        '250': '22153',
        '300': '23199',
        '350': '24621',
        '400': '25966',
        '450': '26490',
        '500': '26903',
        '600': '27987',
        '700': '33225',
        '800': '34718',
        '900': '35319',
        '1000': '36517',
        '1200': '38760',
        '1400': '42538',
        '1600': '45868',
        '1800': '49984',
        '2000': '53797',
    },
    {
        '25': '11192',
        '50': '15233',
        '100': '20095',
        '150': '21105',
        '200': '21590',
        '250': '22454',
        '300': '23499',
        '350': '24960',
        '400': '26302',
        '450': '26865',
        '500': '27316',
        '600': '28400',
        '700': '33561',
        '800': '35056',
        '900': '35846',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '11378',
        '50': '15417',
        '100': '20320',
        '150': '21332',
        '200': '21926',
        '250': '22752',
        '300': '23799',
        '350': '25295',
        '400': '26640',
        '450': '27237',
        '500': '27726',
        '600': '28811',
        '700': '33898',
        '800': '35392',
        '900': '36365',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '11564',
        '50': '15604',
        '100': '20541',
        '150': '21554',
        '200': '22264',
        '250': '23050',
        '300': '24096',
        '350': '25632',
        '400': '26976',
        '450': '27611',
        '500': '28138',
        '600': '29222',
        '700': '34235',
        '800': '35729',
        '900': '36891',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '11754',
        '50': '15793',
        '100': '20766',
        '150': '21778',
        '200': '22601',
        '250': '23348',
        '300': '24392',
        '350': '25966',
        '400': '27316',
        '450': '27987',
        '500': '28547',
        '600': '29631',
        '700': '34571',
        '800': '36065',
        '900': '37415',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '11941',
        '50': '15977',
        '100': '20996',
        '150': '22005',
        '200': '22938',
        '250': '23647',
        '300': '24696',
        '350': '26302',
        '400': '27651',
        '450': '28358',
        '500': '28959',
        '600': '30046',
        '700': '34906',
        '800': '36404',
        '900': '37935',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '12127',
        '50': '16166',
        '100': '21216',
        '150': '22227',
        '200': '23274',
        '250': '23948',
        '300': '24997',
        '350': '26640',
        '400': '27987',
        '450': '28736',
        '500': '29371',
        '600': '30456',
        '700': '35245',
        '800': '36740',
        '900': '38461',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '12313',
        '50': '16356',
        '100': '21441',
        '150': '22454',
        '200': '23611',
        '250': '24247',
        '300': '25295',
        '350': '26976',
        '400': '28324',
        '450': '29111',
        '500': '29782',
        '600': '30869',
        '700': '35582',
        '800': '37080',
        '900': '38984',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '12504',
        '50': '16543',
        '100': '21669',
        '150': '22675',
        '200': '23948',
        '250': '24546',
        '300': '25595',
        '350': '27316',
        '400': '28663',
        '450': '29485',
        '500': '30194',
        '600': '31279',
        '700': '35918',
        '800': '37415',
        '900': '39508',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '12688',
        '50': '16726',
        '100': '21890',
        '150': '22902',
        '200': '24285',
        '250': '24847',
        '300': '25894',
        '350': '27651',
        '400': '28996',
        '450': '29859',
        '500': '30606',
        '600': '31693',
        '700': '36255',
        '800': '37749',
        '900': '40031',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '12840',
        '50': '16914',
        '100': '22115',
        '150': '23124',
        '200': '24582',
        '250': '25145',
        '300': '26193',
        '350': '27987',
        '400': '29332',
        '450': '30234',
        '500': '31016',
        '600': '32102',
        '700': '36590',
        '800': '38087',
        '900': '40555',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '12988',
        '50': '17103',
        '100': '22415',
        '150': '23424',
        '200': '24884',
        '250': '25445',
        '300': '26565',
        '350': '28324',
        '400': '29669',
        '450': '30644',
        '500': '31427',
        '600': '32663',
        '700': '36927',
        '800': '38497',
        '900': '41004',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '13097',
        '50': '17291',
        '100': '22713',
        '150': '23725',
        '200': '25179',
        '250': '25742',
        '300': '26939',
        '350': '28663',
        '400': '30007',
        '450': '31057',
        '500': '31841',
        '600': '33225',
        '700': '37263',
        '800': '38909',
        '900': '41451',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '13212',
        '50': '17475',
        '100': '23012',
        '150': '24023',
        '200': '25480',
        '250': '26041',
        '300': '27316',
        '350': '28996',
        '400': '30343',
        '450': '31465',
        '500': '32251',
        '600': '33786',
        '700': '37601',
        '800': '39319',
        '900': '41901',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '13325',
        '50': '17663',
        '100': '23312',
        '150': '24324',
        '200': '25781',
        '250': '26343',
        '300': '27689',
        '350': '29332',
        '400': '30681',
        '450': '31878',
        '500': '32663',
        '600': '34346',
        '700': '37935',
        '800': '39735',
        '900': '42353',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '13435',
        '50': '17850',
        '100': '23611',
        '150': '24621',
        '200': '26081',
        '250': '26640',
        '300': '28062',
        '350': '29669',
        '400': '31016',
        '450': '32291',
        '500': '33076',
        '600': '34906',
        '700': '38273',
        '800': '40144',
        '900': '42801',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '13587',
        '50': '18037',
        '100': '23908',
        '150': '24922',
        '200': '26377',
        '250': '26939',
        '300': '28434',
        '350': '30007',
        '400': '31355',
        '450': '32701',
        '500': '33484',
        '600': '35468',
        '700': '38611',
        '800': '40555',
        '900': '43251',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '13735',
        '50': '18226',
        '100': '24211',
        '150': '25218',
        '200': '26679',
        '250': '27237',
        '300': '28811',
        '350': '30343',
        '400': '31693',
        '450': '33114',
        '500': '33898',
        '600': '36029',
        '700': '38947',
        '800': '40966',
        '900': '43698',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '13886',
        '50': '18413',
        '100': '24510',
        '150': '25519',
        '200': '26976',
        '250': '27540',
        '300': '29183',
        '350': '30681',
        '400': '32028',
        '450': '33522',
        '500': '34308',
        '600': '36590',
        '700': '39284',
        '800': '41379',
        '900': '44148',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '14036',
        '50': '18602',
        '100': '24807',
        '150': '25817',
        '200': '27275',
        '250': '27839',
        '300': '29558',
        '350': '31016',
        '400': '32365',
        '450': '33935',
        '500': '34718',
        '600': '37153',
        '700': '39620',
        '800': '41787',
        '900': '44593',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '14183',
        '50': '18784',
        '100': '25106',
        '150': '26119',
        '200': '27574',
        '250': '28138',
        '300': '29932',
        '350': '31355',
        '400': '32701',
        '450': '34346',
        '500': '35133',
        '600': '37715',
        '700': '39958',
        '800': '41941',
        '900': '44747',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '14336',
        '50': '18972',
        '100': '25406',
        '150': '26377',
        '200': '27874',
        '250': '28509',
        '300': '30381',
        '350': '31804',
        '400': '33148',
        '450': '34906',
        '500': '35882',
        '600': '38423',
        '700': '40703',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '14447',
        '50': '19160',
        '100': '25705',
        '150': '26640',
        '200': '28177',
        '250': '28883',
        '300': '30828',
        '350': '32251',
        '400': '33598',
        '450': '35468',
        '500': '36628',
        '600': '39137',
        '700': '41342',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '14560',
        '50': '19348',
        '100': '26005',
        '150': '26903',
        '200': '28475',
        '250': '29259',
        '300': '31279',
        '350': '32701',
        '400': '34047',
        '450': '36029',
        '500': '37376',
        '600': '39844',
        '700': '42202',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '14670',
        '50': '19534',
        '100': '26302',
        '150': '27163',
        '200': '28774',
        '250': '29631',
        '300': '31727',
        '350': '33148',
        '400': '34498',
        '450': '36590',
        '500': '38124',
        '600': '40555',
        '700': '42951',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '14782',
        '50': '19721',
        '100': '26605',
        '150': '27426',
        '200': '29072',
        '250': '30007',
        '300': '32176',
        '350': '33598',
        '400': '34943',
        '450': '37153',
        '500': '38872',
        '600': '41266',
        '700': '43698',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '14895',
        '50': '19911',
        '100': '26903',
        '150': '27689',
        '200': '29371',
        '250': '30381',
        '300': '32629',
        '350': '34047',
        '400': '35392',
        '450': '37715',
        '500': '39620',
        '600': '41976',
        '700': '44444',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '15006',
        '50': '20095',
        '100': '27202',
        '150': '27948',
        '200': '29669',
        '250': '30752',
        '300': '33076',
        '350': '34498',
        '400': '35846',
        '450': '38273',
        '500': '40369',
        '600': '42687',
        '700': '45081',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '15121',
        '50': '20283',
        '100': '27502',
        '150': '28210',
        '200': '29971',
        '250': '31129',
        '300': '33522',
        '350': '34943',
        '400': '36292',
        '450': '38836',
        '500': '41117',
        '600': '43399',
        '700': '45942',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '15233',
        '50': '20470',
        '100': '27800',
        '150': '28475',
        '200': '30267',
        '250': '31502',
        '300': '33970',
        '350': '35392',
        '400': '36740',
        '450': '39395',
        '500': '41866',
        '600': '44109',
        '700': '46690',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '15344',
        '50': '20656',
        '100': '28102',
        '150': '28774',
        '200': '30571',
        '250': '31878',
        '300': '34422',
        '350': '35846',
        '400': '37186',
        '450': '39958',
        '500': '42613',
        '600': '44821',
        '700': '47440',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '15455',
        '50': '20843',
        '100': '28400',
        '150': '29072',
        '200': '30828',
        '250': '32251',
        '300': '34870',
        '350': '36328',
        '400': '37601',
        '450': '40408',
        '500': '43061',
        '600': '45306',
        '700': '47926',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '15568',
        '50': '21029',
        '100': '28696',
        '150': '29371',
        '200': '31091',
        '250': '32629',
        '300': '35319',
        '350': '36814',
        '400': '38087',
        '450': '40856',
        '500': '43509',
        '600': '45793',
        '700': '48411',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '15681',
        '50': '21216',
        '100': '28996',
        '150': '29669',
        '200': '31355',
        '250': '33000',
        '300': '35768',
        '350': '37300',
        '400': '38535',
        '450': '41303',
        '500': '43962',
        '600': '46279',
        '700': '48820',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '15793',
        '50': '21405',
        '100': '29297',
        '150': '29971',
        '200': '31616',
        '250': '33377',
        '300': '36218',
        '350': '37788',
        '400': '38984',
        '450': '41752',
        '500': '44409',
        '600': '46764',
        '700': '49382',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '15905',
        '50': '21590',
        '100': '29596',
        '150': '30267',
        '200': '31878',
        '250': '33750',
        '300': '36664',
        '350': '38273',
        '400': '39433',
        '450': '42202',
        '500': '44858',
        '600': '47251',
        '700': '49869',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '16021',
        '50': '21778',
        '100': '29898',
        '150': '30571',
        '200': '32137',
        '250': '34121',
        '300': '37113',
        '350': '38760',
        '400': '39882',
        '450': '42650',
        '500': '45306',
        '600': '47736',
        '700': '50355',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '16130',
        '50': '21964',
        '100': '30194',
        '150': '30869',
        '200': '32400',
        '250': '34498',
        '300': '37563',
        '350': '39245',
        '400': '40330',
        '450': '43097',
        '500': '45755',
        '600': '48224',
        '700': '50842',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '16240',
        '50': '22153',
        '100': '30494',
        '150': '31167',
        '200': '32663',
        '250': '34870',
        '300': '38012',
        '350': '39735',
        '400': '40782',
        '450': '43548',
        '500': '46204',
        '600': '48711',
        '700': '51326',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '16356',
        '50': '22339',
        '100': '30792',
        '150': '31465',
        '200': '32924',
        '250': '35245',
        '300': '38461',
        '350': '40219',
        '400': '41229',
        '450': '43999',
        '500': '46654',
        '600': '49196',
        '700': '51816',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '16466',
        '50': '22525',
        '100': '31091',
        '150': '31765',
        '200': '33187',
        '250': '35619',
        '300': '38909',
        '350': '40703',
        '400': '41680',
        '450': '44444',
        '500': '47101',
        '600': '49684',
        '700': '52228',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '16579',
        '50': '22713',
        '100': '31355',
        '150': '31955',
        '200': '33484',
        '250': '36029',
        '300': '39284',
        '350': '41079',
        '400': '42125',
        '450': '44897',
        '500': '47550',
        '600': '50170',
        '700': '52566',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '16694',
        '50': '22902',
        '100': '31616',
        '150': '32137',
        '200': '33786',
        '250': '36441',
        '300': '39656',
        '350': '41451',
        '400': '42574',
        '450': '45342',
        '500': '47999',
        '600': '50653',
        '700': '53048',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '16803',
        '50': '23089',
        '100': '31878',
        '150': '32327',
        '200': '34085',
        '250': '36850',
        '300': '40031',
        '350': '41828',
        '400': '43022',
        '450': '45793',
        '500': '48448',
        '600': '51140',
        '700': '53459',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '16914',
        '50': '23274',
        '100': '32137',
        '150': '32513',
        '200': '34384',
        '250': '37263',
        '300': '40408',
        '350': '42202',
        '400': '43474',
        '450': '46238',
        '500': '48898',
        '600': '51626',
        '700': '53873',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '17029',
        '50': '23462',
        '100': '32400',
        '150': '32701',
        '200': '34682',
        '250': '37676',
        '300': '40782',
        '350': '42574',
        '400': '43920',
        '450': '46391',
        '500': '49048',
        '600': '51777',
        '700': '54022',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '17139',
        '50': '23647',
        '100': '32663',
        '150': '32885',
        '200': '34982',
        '250': '38087',
        '300': '41154',
        '350': '42951',
        '400': '44371',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '17252',
        '50': '23799',
        '100': '32924',
        '150': '33076',
        '200': '35279',
        '250': '38497',
        '300': '41530',
        '350': '43327',
        '400': '44821',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '17362',
        '50': '23948',
        '100': '33187',
        '150': '33336',
        '200': '35582',
        '250': '38909',
        '300': '41901',
        '350': '43698',
        '400': '45081',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '17475',
        '50': '24096',
        '100': '33450',
        '150': '33635',
        '200': '35882',
        '250': '39319',
        '300': '42277',
        '350': '44073',
        '400': '45720',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '17588',
        '50': '24247',
        '100': '33711',
        '150': '33825',
        '200': '36178',
        '250': '39735',
        '300': '42650',
        '350': '44444',
        '400': '46166',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '17701',
        '50': '24392',
        '100': '33935',
        '150': '34008',
        '200': '36441',
        '250': '40031',
        '300': '42990',
        '350': '44783',
        '400': '46504',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '17815',
        '50': '24546',
        '100': '34160',
        '150': '34270',
        '200': '36703',
        '250': '40330',
        '300': '43327',
        '350': '45120',
        '400': '46839',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '17888',
        '50': '24696',
        '100': '34384',
        '150': '34460',
        '200': '36966',
        '250': '40629',
        '300': '43660',
        '350': '45457',
        '400': '47177',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '17963',
        '50': '24847',
        '100': '34605',
        '150': '34682',
        '200': '37230',
        '250': '40932',
        '300': '43999',
        '350': '45793',
        '400': '47513',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18037',
        '50': '24997',
        '100': '34834',
        '150': '34943',
        '200': '37488',
        '250': '41229',
        '300': '44335',
        '350': '46130',
        '400': '47852',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18113',
        '50': '25069',
        '100': '35056',
        '150': '35206',
        '200': '37749',
        '250': '41530',
        '300': '44670',
        '350': '46468',
        '400': '48186',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18187',
        '50': '25145',
        '100': '35279',
        '150': '35468',
        '200': '38012',
        '250': '41828',
        '300': '45007',
        '350': '46805',
        '400': '48524',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18299',
        '50': '25218',
        '100': '35507',
        '150': '35729',
        '200': '38273',
        '250': '42125',
        '300': '45342',
        '350': '47141',
        '400': '48820',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18373',
        '50': '25295',
        '100': '35729',
        '150': '35992',
        '200': '38535',
        '250': '42425',
        '300': '45679',
        '350': '47473',
        '400': '49196',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18413',
        '50': '25369',
        '100': '35918',
        '150': '36255',
        '200': '38798',
        '250': '42725',
        '300': '46018',
        '350': '47811',
        '400': '49493',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18450',
        '50': '25445',
        '100': '36065',
        '150': '36517',
        '200': '38984',
        '250': '42913',
        '300': '46204',
        '350': '48075',
        '400': '49795',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18487',
        '50': '25519',
        '100': '36218',
        '150': '36778',
        '200': '39172',
        '250': '43097',
        '300': '46391',
        '350': '48336',
        '400': '50094',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18526',
        '50': '25595',
        '100': '36365',
        '150': '37039',
        '200': '39360',
        '250': '43286',
        '300': '46578',
        '350': '48599',
        '400': '50394',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18562',
        '50': '25667',
        '100': '36517',
        '150': '37300',
        '200': '39547',
        '250': '43474',
        '300': '46764',
        '350': '48860',
        '400': '50690',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18602',
        '50': '25742',
        '100': '36664',
        '150': '37563',
        '200': '39735',
        '250': '43660',
        '300': '46953',
        '350': '49120',
        '400': '50991',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18635',
        '50': '25817',
        '100': '36814',
        '150': '37824',
        '200': '39919',
        '250': '43845',
        '300': '47141',
        '350': '49382',
        '400': '51288',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18671',
        '50': '25894',
        '100': '36966',
        '150': '38087',
        '200': '40108',
        '250': '44034',
        '300': '47326',
        '350': '49646',
        '400': '51589',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18709',
        '50': '25966',
        '100': '37113',
        '150': '38351',
        '200': '40296',
        '250': '44221',
        '300': '47513',
        '350': '49908',
        '400': '51892',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18748',
        '50': '26041',
        '100': '37263',
        '150': '38611',
        '200': '40480',
        '250': '44409',
        '300': '47699',
        '350': '50170',
        '400': '52189',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18784',
        '50': '26119',
        '100': '37415',
        '150': '38760',
        '200': '40629',
        '250': '44558',
        '300': '47852',
        '350': '50319',
        '400': '52337',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18823',
        '50': '26193',
        '100': '37563',
        '150': '38909',
        '200': '40782',
        '250': '44708',
        '300': '47999',
        '350': '50469',
        '400': '52490',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18860',
        '50': '26269',
        '100': '37715',
        '150': '39060',
        '200': '40932',
        '250': '44858',
        '300': '48147',
        '350': '50618',
        '400': '52638',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18899',
        '50': '26343',
        '100': '37861',
        '150': '39209',
        '200': '41079',
        '250': '45007',
        '300': '48298',
        '350': '50767',
        '400': '52787',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18937',
        '50': '26416',
        '100': '38012',
        '150': '39360',
        '200': '41229',
        '250': '45156',
        '300': '48448',
        '350': '50918',
        '400': '52937',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '18972',
        '50': '26490',
        '100': '38162',
        '150': '39508',
        '200': '41379',
        '250': '45306',
        '300': '48599',
        '350': '51068',
        '400': '53084',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19010',
        '50': '26565',
        '100': '38312',
        '150': '39656',
        '200': '41530',
        '250': '45457',
        '300': '48744',
        '350': '51216',
        '400': '53238',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19046',
        '50': '26640',
        '100': '38461',
        '150': '39806',
        '200': '41680',
        '250': '45603',
        '300': '48898',
        '350': '51363',
        '400': '53386',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19086',
        '50': '26717',
        '100': '38611',
        '150': '39958',
        '200': '41828',
        '250': '45755',
        '300': '49048',
        '350': '51515',
        '400': '53535',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19120',
        '50': '26790',
        '100': '38760',
        '150': '40108',
        '200': '41976',
        '250': '45904',
        '300': '49196',
        '350': '51665',
        '400': '53683',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19160',
        '50': '26865',
        '100': '38909',
        '150': '40255',
        '200': '42125',
        '250': '46054',
        '300': '49348',
        '350': '51816',
        '400': '53833',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19200',
        '50': '26939',
        '100': '39060',
        '150': '40408',
        '200': '42277',
        '250': '46204',
        '300': '49493',
        '350': '51963',
        '400': '53983',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19237',
        '50': '27016',
        '100': '39209',
        '150': '40555',
        '200': '42425',
        '250': '46351',
        '300': '49646',
        '350': '52113',
        '400': '54135',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19276',
        '50': '27089',
        '100': '39360',
        '150': '40703',
        '200': '42574',
        '250': '46504',
        '300': '49795',
        '350': '52261',
        '400': '54285',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19308',
        '50': '27163',
        '100': '39508',
        '150': '40856',
        '200': '42725',
        '250': '46654',
        '300': '49942',
        '350': '52411',
        '400': '54434',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19348',
        '50': '27237',
        '100': '39656',
        '150': '41004',
        '200': '42874',
        '250': '46805',
        '300': '50094',
        '350': '52566',
        '400': '54584',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19382',
        '50': '27316',
        '100': '39806',
        '150': '41154',
        '200': '43022',
        '250': '46953',
        '300': '50244',
        '350': '52712',
        '400': '54731',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19423',
        '50': '27390',
        '100': '39958',
        '150': '41303',
        '200': '43173',
        '250': '47101',
        '300': '50394',
        '350': '52862',
        '400': '54880',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19457',
        '50': '27465',
        '100': '40108',
        '150': '41451',
        '200': '43327',
        '250': '47251',
        '300': '50542',
        '350': '53011',
        '400': '55034',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19495',
        '50': '27540',
        '100': '40255',
        '150': '41604',
        '200': '43474',
        '250': '47401',
        '300': '50690',
        '350': '53163',
        '400': '55180',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19534',
        '50': '27611',
        '100': '40408',
        '150': '41752',
        '200': '43624',
        '250': '47550',
        '300': '50842',
        '350': '53311',
        '400': '55330',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19572',
        '50': '27689',
        '100': '40555',
        '150': '41901',
        '200': '43771',
        '250': '47699',
        '300': '50991',
        '350': '53459',
        '400': '55478',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19611',
        '50': '27762',
        '100': '40703',
        '150': '42051',
        '200': '43920',
        '250': '47852',
        '300': '51140',
        '350': '53610',
        '400': '55630',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19645',
        '50': '27839',
        '100': '40856',
        '150': '42202',
        '200': '44073',
        '250': '47999',
        '300': '51288',
        '350': '53760',
        '400': '55781',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19684',
        '50': '27914',
        '100': '41004',
        '150': '42353',
        '200': '44221',
        '250': '48147',
        '300': '51441',
        '350': '53908',
        '400': '55928',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19721',
        '50': '27987',
        '100': '41154',
        '150': '42501',
        '200': '44371',
        '250': '48298',
        '300': '51589',
        '350': '54058',
        '400': '56079',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19758',
        '50': '28062',
        '100': '41303',
        '150': '42650',
        '200': '44521',
        '250': '48448',
        '300': '51741',
        '350': '54209',
        '400': '56227',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19795',
        '50': '28138',
        '100': '41451',
        '150': '42801',
        '200': '44670',
        '250': '48599',
        '300': '51892',
        '350': '54359',
        '400': '56379',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19834',
        '50': '28210',
        '100': '41604',
        '150': '42951',
        '200': '44821',
        '250': '48744',
        '300': '52039',
        '350': '54507',
        '400': '56528',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19867',
        '50': '28286',
        '100': '41752',
        '150': '43097',
        '200': '44967',
        '250': '48898',
        '300': '52189',
        '350': '54655',
        '400': '56678',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19911',
        '50': '28358',
        '100': '41901',
        '150': '43251',
        '200': '45120',
        '250': '49048',
        '300': '52337',
        '350': '54804',
        '400': '56828',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19944',
        '50': '28434',
        '100': '42051',
        '150': '43399',
        '200': '45269',
        '250': '49196',
        '300': '52490',
        '350': '54961',
        '400': '56977',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '19983',
        '50': '28509',
        '100': '42202',
        '150': '43548',
        '200': '45417',
        '250': '49348',
        '300': '52638',
        '350': '55108',
        '400': '57124',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20021',
        '50': '28587',
        '100': '42353',
        '150': '43698',
        '200': '45566',
        '250': '49493',
        '300': '52787',
        '350': '55256',
        '400': '57274',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20057',
        '50': '28663',
        '100': '42501',
        '150': '43845',
        '200': '45720',
        '250': '49646',
        '300': '52937',
        '350': '55406',
        '400': '57427',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20095',
        '50': '28736',
        '100': '42650',
        '150': '43999',
        '200': '45868',
        '250': '49795',
        '300': '53084',
        '350': '55554',
        '400': '57576',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20130',
        '50': '28811',
        '100': '42801',
        '150': '44148',
        '200': '46018',
        '250': '49942',
        '300': '53238',
        '350': '55707',
        '400': '57723',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20170',
        '50': '28883',
        '100': '42951',
        '150': '44295',
        '200': '46166',
        '250': '50094',
        '300': '53386',
        '350': '55853',
        '400': '57873',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20207',
        '50': '28959',
        '100': '43097',
        '150': '44444',
        '200': '46315',
        '250': '50244',
        '300': '53535',
        '350': '56005',
        '400': '58023',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20244',
        '50': '29033',
        '100': '43251',
        '150': '44593',
        '200': '46468',
        '250': '50394',
        '300': '53683',
        '350': '56155',
        '400': '58175',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20283',
        '50': '29111',
        '100': '43399',
        '150': '44747',
        '200': '46615',
        '250': '50542',
        '300': '53833',
        '350': '56302',
        '400': '58322',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20320',
        '50': '29183',
        '100': '43548',
        '150': '44897',
        '200': '46764',
        '250': '50690',
        '300': '53983',
        '350': '56451',
        '400': '58473',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20358',
        '50': '29259',
        '100': '43698',
        '150': '45045',
        '200': '46915',
        '250': '50842',
        '300': '54135',
        '350': '56602',
        '400': '58621',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20393',
        '50': '29332',
        '100': '43845',
        '150': '45194',
        '200': '47063',
        '250': '50991',
        '300': '54285',
        '350': '56752',
        '400': '58770',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20431',
        '50': '29409',
        '100': '43999',
        '150': '45342',
        '200': '47215',
        '250': '51140',
        '300': '54434',
        '350': '56902',
        '400': '58926',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20470',
        '50': '29485',
        '100': '44148',
        '150': '45493',
        '200': '47363',
        '250': '51288',
        '300': '54584',
        '350': '57051',
        '400': '59071',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20507',
        '50': '29558',
        '100': '44295',
        '150': '45642',
        '200': '47513',
        '250': '51441',
        '300': '54731',
        '350': '57199',
        '400': '59222',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20541',
        '50': '29631',
        '100': '44444',
        '150': '45793',
        '200': '47663',
        '250': '51589',
        '300': '54880',
        '350': '57351',
        '400': '59371',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20579',
        '50': '29708',
        '100': '44593',
        '150': '45942',
        '200': '47811',
        '250': '51741',
        '300': '55034',
        '350': '57501',
        '400': '59520',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20617',
        '50': '29782',
        '100': '44747',
        '150': '46092',
        '200': '47961',
        '250': '51892',
        '300': '55180',
        '350': '57651',
        '400': '59670',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20656',
        '50': '29859',
        '100': '44897',
        '150': '46238',
        '200': '48110',
        '250': '52039',
        '300': '55330',
        '350': '57800',
        '400': '59819',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20693',
        '50': '29932',
        '100': '45045',
        '150': '46391',
        '200': '48262',
        '250': '52189',
        '300': '55478',
        '350': '57949',
        '400': '59969',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20730',
        '50': '30007',
        '100': '45194',
        '150': '46540',
        '200': '48411',
        '250': '52337',
        '300': '55630',
        '350': '58101',
        '400': '60119',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20766',
        '50': '30081',
        '100': '45342',
        '150': '46690',
        '200': '48561',
        '250': '52490',
        '300': '55781',
        '350': '58249',
        '400': '60269',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20807',
        '50': '30161',
        '100': '45493',
        '150': '46839',
        '200': '48711',
        '250': '52638',
        '300': '55928',
        '350': '58397',
        '400': '60417',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20843',
        '50': '30234',
        '100': '45642',
        '150': '46987',
        '200': '48860',
        '250': '52787',
        '300': '56079',
        '350': '58549',
        '400': '60564',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20879',
        '50': '30308',
        '100': '45793',
        '150': '47141',
        '200': '49010',
        '250': '52937',
        '300': '56227',
        '350': '58697',
        '400': '60717',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20918',
        '50': '30381',
        '100': '45942',
        '150': '47290',
        '200': '49159',
        '250': '53084',
        '300': '56379',
        '350': '58847',
        '400': '60868',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20956',
        '50': '30456',
        '100': '46092',
        '150': '47440',
        '200': '49310',
        '250': '53238',
        '300': '56528',
        '350': '58999',
        '400': '61015',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '20996',
        '50': '30533',
        '100': '46238',
        '150': '47589',
        '200': '49457',
        '250': '53386',
        '300': '56678',
        '350': '59146',
        '400': '61164',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21029',
        '50': '30606',
        '100': '46391',
        '150': '47736',
        '200': '49609',
        '250': '53535',
        '300': '56828',
        '350': '59296',
        '400': '61317',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21068',
        '50': '30681',
        '100': '46540',
        '150': '47888',
        '200': '49756',
        '250': '53683',
        '300': '56977',
        '350': '59443',
        '400': '61467',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21105',
        '50': '30752',
        '100': '46690',
        '150': '48039',
        '200': '49908',
        '250': '53833',
        '300': '57124',
        '350': '59594',
        '400': '61614',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21143',
        '50': '30828',
        '100': '46839',
        '150': '48186',
        '200': '50056',
        '250': '53983',
        '300': '57274',
        '350': '59744',
        '400': '61764',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21178',
        '50': '30905',
        '100': '46987',
        '150': '48336',
        '200': '50204',
        '250': '54135',
        '300': '57427',
        '350': '59896',
        '400': '61913',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21216',
        '50': '30981',
        '100': '47141',
        '150': '48485',
        '200': '50355',
        '250': '54285',
        '300': '57576',
        '350': '60045',
        '400': '62066',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21251',
        '50': '31057',
        '100': '47290',
        '150': '48635',
        '200': '50505',
        '250': '54434',
        '300': '57723',
        '350': '60195',
        '400': '62215',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21293',
        '50': '31129',
        '100': '47440',
        '150': '48783',
        '200': '50653',
        '250': '54584',
        '300': '57873',
        '350': '60343',
        '400': '62363',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21332',
        '50': '31206',
        '100': '47589',
        '150': '48934',
        '200': '50805',
        '250': '54731',
        '300': '58023',
        '350': '60492',
        '400': '62512',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21366',
        '50': '31279',
        '100': '47736',
        '150': '49083',
        '200': '50953',
        '250': '54880',
        '300': '58175',
        '350': '60643',
        '400': '62662',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21405',
        '50': '31355',
        '100': '47888',
        '150': '49233',
        '200': '51105',
        '250': '55034',
        '300': '58322',
        '350': '60793',
        '400': '62812',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21441',
        '50': '31427',
        '100': '48039',
        '150': '49382',
        '200': '51255',
        '250': '55180',
        '300': '58473',
        '350': '60945',
        '400': '62959',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21481',
        '50': '31502',
        '100': '48186',
        '150': '49531',
        '200': '51403',
        '250': '55330',
        '300': '58621',
        '350': '61090',
        '400': '63111',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21514',
        '50': '31578',
        '100': '48336',
        '150': '49684',
        '200': '51553',
        '250': '55478',
        '300': '58770',
        '350': '61240',
        '400': '63261',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21554',
        '50': '31653',
        '100': '48485',
        '150': '49833',
        '200': '51702',
        '250': '55630',
        '300': '58926',
        '350': '61391',
        '400': '63411',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21590',
        '50': '31727',
        '100': '48635',
        '150': '49984',
        '200': '51853',
        '250': '55781',
        '300': '59071',
        '350': '61541',
        '400': '63559',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21628',
        '50': '31804',
        '100': '48783',
        '150': '50131',
        '200': '52001',
        '250': '55928',
        '300': '59222',
        '350': '61690',
        '400': '63707',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21669',
        '50': '31878',
        '100': '48934',
        '150': '50280',
        '200': '52151',
        '250': '56079',
        '300': '59371',
        '350': '61838',
        '400': '63861',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21704',
        '50': '31955',
        '100': '49083',
        '150': '50433',
        '200': '52302',
        '250': '56227',
        '300': '59520',
        '350': '61990',
        '400': '64010',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21743',
        '50': '32028',
        '100': '49233',
        '150': '50581',
        '200': '52452',
        '250': '56379',
        '300': '59670',
        '350': '62139',
        '400': '64159',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21778',
        '50': '32102',
        '100': '49382',
        '150': '50730',
        '200': '52598',
        '250': '56528',
        '300': '59819',
        '350': '62286',
        '400': '64308',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21817',
        '50': '32176',
        '100': '49531',
        '150': '50877',
        '200': '52747',
        '250': '56678',
        '300': '59969',
        '350': '62439',
        '400': '64458',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21851',
        '50': '32251',
        '100': '49684',
        '150': '51030',
        '200': '52900',
        '250': '56828',
        '300': '60119',
        '350': '62588',
        '400': '64609',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21890',
        '50': '32327',
        '100': '49833',
        '150': '51179',
        '200': '53048',
        '250': '56977',
        '300': '60269',
        '350': '62739',
        '400': '64758',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21926',
        '50': '32400',
        '100': '49984',
        '150': '51326',
        '200': '53201',
        '250': '57124',
        '300': '60417',
        '350': '62887',
        '400': '64907',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '21964',
        '50': '32476',
        '100': '50131',
        '150': '51477',
        '200': '53347',
        '250': '57274',
        '300': '60564',
        '350': '63035',
        '400': '65055',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22005',
        '50': '32550',
        '100': '50280',
        '150': '51626',
        '200': '53500',
        '250': '57427',
        '300': '60717',
        '350': '63188',
        '400': '65207',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22040',
        '50': '32629',
        '100': '50433',
        '150': '51777',
        '200': '53650',
        '250': '57576',
        '300': '60868',
        '350': '63337',
        '400': '65354',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22078',
        '50': '32701',
        '100': '50581',
        '150': '51925',
        '200': '53797',
        '250': '57723',
        '300': '61015',
        '350': '63486',
        '400': '65503',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22115',
        '50': '32776',
        '100': '50730',
        '150': '52075',
        '200': '53946',
        '250': '57873',
        '300': '61164',
        '350': '63633',
        '400': '65656',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22153',
        '50': '32849',
        '100': '50877',
        '150': '52228',
        '200': '54096',
        '250': '58023',
        '300': '61317',
        '350': '63786',
        '400': '65803',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22189',
        '50': '32924',
        '100': '51030',
        '150': '52376',
        '200': '54246',
        '250': '58175',
        '300': '61467',
        '350': '63934',
        '400': '65954',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22227',
        '50': '33000',
        '100': '51179',
        '150': '52526',
        '200': '54395',
        '250': '58322',
        '300': '61614',
        '350': '64084',
        '400': '66099',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22264',
        '50': '33076',
        '100': '51326',
        '150': '52674',
        '200': '54544',
        '250': '58473',
        '300': '61764',
        '350': '64232',
        '400': '66256',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22301',
        '50': '33148',
        '100': '51477',
        '150': '52828',
        '200': '54695',
        '250': '58621',
        '300': '61913',
        '350': '64381',
        '400': '66404',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22339',
        '50': '33225',
        '100': '51626',
        '150': '52975',
        '200': '54843',
        '250': '58770',
        '300': '62066',
        '350': '64532',
        '400': '66552',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22378',
        '50': '33295',
        '100': '51777',
        '150': '53124',
        '200': '54994',
        '250': '58926',
        '300': '62215',
        '350': '64682',
        '400': '66705',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22415',
        '50': '33377',
        '100': '51925',
        '150': '53272',
        '200': '55142',
        '250': '59071',
        '300': '62363',
        '350': '64836',
        '400': '66852',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22454',
        '50': '33450',
        '100': '52075',
        '150': '53420',
        '200': '55294',
        '250': '59222',
        '300': '62512',
        '350': '64982',
        '400': '67002',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22489',
        '50': '33522',
        '100': '52228',
        '150': '53573',
        '200': '55443',
        '250': '59371',
        '300': '62662',
        '350': '65131',
        '400': '67152',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22525',
        '50': '33598',
        '100': '52376',
        '150': '53722',
        '200': '55592',
        '250': '59520',
        '300': '62812',
        '350': '65282',
        '400': '67303',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
    {
        '25': '22525',
        '50': '33598',
        '100': '52376',
        '150': '53722',
        '200': '55592',
        '250': '59520',
        '300': '62812',
        '350': '65282',
        '400': '67303',
        '450': '',
        '500': '',
        '600': '',
        '700': '',
        '800': '',
        '900': '',
        '1000': '',
        '1200': '',
        '1400': '',
        '1600': '',
        '1800': '',
        '2000': '',
    },
]
